module.exports = __webpack_public_path__ + "img/caret-right-circle.b93d3b43.svg";